import React, { useState } from 'react';
import { CheckCircle } from 'lucide-react';
import { useCognito } from 'common/hooks';
import { useNavigate } from 'react-router-dom';
import { usePostLogin } from 'services/hooks/mutations';

import styles from '../ForgotPasswordModal.module.scss';

type SuccessStepProps = {
    userEmail: string;
    userPassword: string;
    onLoginSuccess: () => void;
};

export const SuccessStep: React.FC<SuccessStepProps> = ({ userEmail, userPassword, onLoginSuccess }) => {
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const navigate = useNavigate();

    const { authenticateUser } = useCognito();
    const { postLogin } = usePostLogin();

    const handleLoginAndNavigate = async () => {
        setIsLoggingIn(true);

        try {
            authenticateUser(userEmail, userPassword, {
                onSuccess: (result) => {
                    const idToken = result.getIdToken().getJwtToken();

                    postLogin(idToken, {
                        onSuccess: ({ userRole }) => {
                            localStorage.setItem('userRole', JSON.stringify(userRole ?? []));
                            onLoginSuccess();
                            // Non-ACTIVE tenants are redirected by ProtectedRoute after /auth/verify
                            navigate('/dashboard');
                        },
                        onError: (error) => {
                            console.error('Login failed:', error);
                            setIsLoggingIn(false);
                        },
                    });
                },
                onFailure: (err) => {
                    console.error('Login failed after password reset:', err);
                    setIsLoggingIn(false);
                },
            });
        } catch (err) {
            console.error('Login error after password reset:', err);
            setIsLoggingIn(false);
        }
    };
    return (
        <form
            id='login-form'
            onSubmit={(e) => {
                e.preventDefault();
                handleLoginAndNavigate();
            }}
        >
            <div className={styles.stepContainer}>
                <div className={styles.successIconContainer}>
                    <CheckCircle className={styles.successIcon} size={64} />
                </div>
                <div className={styles.successTitle}>Password Reset Successfully!</div>
                <div className={styles.description}>
                    Your password has been reset successfully. Click the button below to log in with your new password.
                </div>
                {isLoggingIn && <div className={styles.description}>Logging you in...</div>}
            </div>
        </form>
    );
};
